import { updateOrderRequest } from '../OrdersUtil';
import { UpdateOrderRequest, Address, Error } from '../../../types/orderTypes';
import { fetchOrder } from '../../../fetch/orderFetch';
import { settings } from '../../../settings';
import Fetch from 'utils/fetch';
import Swal from 'sweetalert2';

export async function updateOrderAddress(
  orderId: string,
  address: Address
): Promise<Error[]> {
  const order = await fetchOrder(orderId);

  const request: UpdateOrderRequest = updateOrderRequest(order);
  request.destination.address = {
    city: address.city,
    country: address.country,
    postalCode: address.postalCode,
    streetName: address.streetName,
    streetNumber: address.streetNumber,
  };

  const response = await Fetch.put({
    url: `${settings.newApiUrl}/order/${order.id}`,
    body: request,
  });

  if (response.ok) {
    return [];
  } else if (response.status < 500) {
    const responseErrors: Error[] = await response.json();
    return responseErrors;
  } else {
    return [
      {
        message: `Something unknown went wrong changing the address of the order.`,
        propertyPath: '',
      },
    ];
  }
}

export function onAddressChange(
  newAddress: Address,
  orderId: string,
  setUpdatedAdressTimesMethod: () => void
) {
  const html = `<div style="font-size: 1.3em;">
          <br/><br/>Please confirm the new address:
          <br/><br/>
          <div style="display: flex; flex-direction: column; align-items: flex-start; padding-left: 50px; font-weight: lighter;">
            <div>Street: <b style="font-weight: 500">${newAddress.streetName}</b></div>
            <div>Number: <b style="font-weight: 500">${newAddress.streetNumber}</b></div>
            <div>City: <b style="font-weight: 500">${newAddress.city}</b></div>
            <div>Postal code: <b style="font-weight: 500">${newAddress.postalCode}</b></div>
            <div>Country: <b style="font-weight: 500">${newAddress.country}</b></div>
          </div>
        </div>
      `;

  Swal.fire({
    html: html,
    title: 'Update address?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Update',
    cancelButtonText: 'Cancel',
  }).then(async result => {
    if (result.value) {
      //const orderId = this.props.orderId;
      const updateResult = await updateOrderAddress(orderId, newAddress);
      if (updateResult.length === 0) {
        setUpdatedAdressTimesMethod();
      } else {
        const errorMessages = (updateResult as Error[])
          .map(
            ({ message, propertyPath }) =>
              `<div style="text-align: left; font-size: 1.5rem; margin-bottom: 5px;">Field: ${propertyPath}<br />Message: ${message}</div>`
          )
          .join('');
        const html = `<div>Sorry, the address could not be updated with that address because:<br /><br />${errorMessages}</div>`;

        await Swal.fire({
          title: 'Could not update address',
          html: html,
          icon: 'error',
        });
      }
    }
  });
}

export async function setAddressLocation(
  orderId: string,
  longitude: number,
  latitude: number
): Promise<boolean> {
  const response: Response = await Fetch.put({
    url: `${settings.newApiUrl}/order/${orderId}/set-address-location`,
    body: {
      longitude: longitude,
      latitude: latitude,
    },
  });
  return response.ok;
}

export function onAddressLocationChange(
  orderId: string,
  longitude: number,
  latitude: number,
  setUpdatedAdressTimesMethod: () => void
): void {
  const html = `<div>
          The recipient address location could not be automatically resolved.
          <br/><br/>Please confirm the new location for the recipient.
          <br/><br/>
          <a
          href="https://maps.google.com/?q=${latitude},${longitude}"
          target="_blank"
          rel="noopener noreferrer">
          Click here to see the selected location in Google Maps
        </a>

        </div>
      `;

  Swal.fire({
    html: html,
    title: 'Update address location?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Update',
    cancelButtonText: 'Cancel',
  })
    .then(async result => {
      if (result.value) {
        await setAddressLocation(orderId, longitude, latitude);
        setUpdatedAdressTimesMethod();
      }
    })
    .catch(error => console.error(error.message));
}
